/**
 * @author sudong.duan
 * Date: 21-12-16
 * desc: 公共方法
 */

/**
 *判断是否为空
 *@param {String}a 变量
 *@return 是否为空
 */
 const isEmpty = function (a) {
	if (a === undefined || a === 'undefined' || a === null || a === 'null' || a === '' || JSON.stringify(a) === '{}' || JSON.stringify(a) === '[]') {
		return true
	}
	return false
}


/**
	判断是否微信环境
	@param 
	@return { Boolean } 是否微信环境
*/
function is_weixin() {  
    var ua = navigator.userAgent.toLowerCase();  
    if(ua.match(/MicroMessenger/i)=="micromessenger") {  
        return true;  
    } else {  
        return false;  
    }  
}

/**
 节流函数
 @param {Function} callback 回调函数
 @return
 */
 const throttleFnc = function (callback) {
	let isLimit = false
	// tslint: disable 
	return function () {
		if (!isLimit) {
			isLimit = true
			// @ts-ignore #
			callback.call(this, function () {
				isLimit = false
				// @ts-ignore #
			}, ...arguments)
		}
	}
}

/**
	日期格式化
	@param {Date}time 时间
	@param {String}format 时间格式
	@return {String} 新格式日期
*/
const dateFormat = function (time, format) {
	if (isEmpty(time)) {
		return ''
	}
	const t = new Date(time)
	const tf = function (i) {
		return (i < 10 ? '0' : '') + i
	}
	return format.replace(/YYYY|MM|DD|hh|mm|ss/g, function (a) {
		switch (a) {
			case 'YYYY':
				return tf(t.getFullYear())
				break
			case 'MM':
				return tf(t.getMonth() + 1)
				break
			case 'DD':
				return tf(t.getDate())
				break
			case 'hh':
				return tf(t.getHours())
				break
			case 'mm':
				return tf(t.getMinutes())
				break
			case 'ss':
				return tf(t.getSeconds())
				break
		}
	})
}

/**
    深拷贝函数
    @param {Object || Array} data 待拷贝的数据
    @return {Object || Array} 拷贝后的数据
*/
const deepClone = function (data) {
    var objClone = Array.isArray(data) ? [] : {};
    if (data && typeof data === "object") {
        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                if (data[key] && typeof data[key] === "object") {
                    objClone[key] = deepClone(data[key]);
                } else {
                    objClone[key] = data[key];
                }
            }
        }
    }
    return objClone;
}




export {
    isEmpty,
	is_weixin,
	throttleFnc,
	dateFormat,
	deepClone
}


// WEBPACK FOOTER //
// ./src/utils/common.js